<template>
  <div class="flex ju-sp al-cn su-title">
    <div class="flex al-cn">
      <div class="leftIcon"></div>
      <div class="ml5 cl333 f20 font-bold">{{title}}</div>
    </div>
    <div v-if="more" class="cl999 f14 discolour" @click="discolour">
      更多
      <i class="el-icon-arrow-right"></i>
    </div>
    <div v-if="custom">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: '标题'
      },
      // 更多
      more: {
        type: Boolean,
        default: true
      },
      // 自定义
      custom: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {

      }
    },
    methods: {
      // 点击更多
      discolour() {
        this.$emit('discolour')
      }
    }
  }
</script>
<style scoped lang="scss">

</style>
